import {
  ChartBar,
  Crosshair,
  CurrencyDollar,
  FileText,
  Lightning,
  PencilLine,
  Phone,
  Rocket,
  Scroll,
  Toolbox,
  User,
  Wrench,
} from "@phosphor-icons/react";

import { cn } from "@/lib/utils";

import { categoryIconColors } from "../data/agents";
import { AgentCategory, PhosphorIconName } from "../types";

const iconMap: Record<PhosphorIconName, typeof Crosshair> = {
  Crosshair,
  ChartBar,
  CurrencyDollar,
  User,
  PencilLine,
  Phone,
  Rocket,
  Scroll,
  FileText,
  Lightning,
  Wrench,
  Toolbox,
};

interface AgentIconProps {
  iconName: PhosphorIconName;
  category: AgentCategory;
  size?: number;
}

export const AgentIcon = ({
  iconName,
  category,
  size = 24,
}: AgentIconProps) => {
  const Icon = iconMap[iconName];
  const colors = categoryIconColors[category];

  return (
    <div
      className={cn(
        "relative flex items-center justify-center rounded-xl p-3",
        "shadow-sm ring-1 ring-black/5",
        "transition-all duration-200",
        colors.bg,
        colors.text,
      )}
    >
      <div className="relative z-10">
        <Icon size={size} weight="duotone" />
      </div>
    </div>
  );
};
